jQuery(function ($) {
	const base = 'growl-component-breeds';
	const breedCard = 'growl-component-breed-card';

	if (!$(`.${base}`).length || !$(`.${breedCard}`).length) {
		return false;
	}

	$(`.${base}__search > input`).on('keyup', function () {
		const value = $(this).val().toLowerCase();

		$(`.${base}__items > .${breedCard}`).each(function () {
			$(this).find(`.${breedCard}__caption > a`).text().toLowerCase().indexOf(value) > -1
				? $(this).show()
				: $(this).hide();
		});
	});
});
